var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00028 15.6431C11.9452 15.6431 15.1431 12.4452 15.1431 8.50028C15.1431 4.55539 11.9452 1.35742 8.00028 1.35742C4.05539 1.35742 0.857422 4.55539 0.857422 8.50028C0.857422 12.4452 4.05539 15.6431 8.00028 15.6431Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 9.59863C4.92445 11.5767 7.12225 12.7854 9.10027 12.236C10.3091 11.7964 11.2981 10.8074 11.6277 9.59863",
    stroke: "#84C70D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9134 6.85218C10.7617 6.85218 10.6387 6.72919 10.6387 6.57746C10.6387 6.42573 10.7617 6.30273 10.9134 6.30273",
    stroke: "#84C70D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9128 6.85218C11.0645 6.85218 11.1875 6.72919 11.1875 6.57746C11.1875 6.42573 11.0645 6.30273 10.9128 6.30273",
    stroke: "#84C70D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08918 6.85218C4.93745 6.85218 4.81445 6.72919 4.81445 6.57746C4.81445 6.42573 4.93745 6.30273 5.08918 6.30273",
    stroke: "#84C70D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08856 6.85218C5.24028 6.85218 5.36328 6.72919 5.36328 6.57746C5.36328 6.42573 5.24028 6.30273 5.08856 6.30273",
    stroke: "#84C70D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.330197f8954b109c0e26776018eb3975.svg";
export { ForwardRef as ReactComponent };